import { request } from '../../Common/api/client';

export function isPaymentPk(value) {
  return /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
}

async function allRows(url, filters, limit, signal) {
  const rows = [];
  let pages = 1;
  for (let page = 1; page <= pages; page += 1) {
    const data = await request({ url, params: { ...filters, page, limit }, signal, timeout: 15000 });
    if (!Array.isArray(data?.rows) || data.total == null || !Number.isSafeInteger(Number(data.total)) || Number(data.total) < 0) {
      throw new Error('목록을 확인하지 못했습니다. 다시 조회해 주세요.');
    }
    const size = Number(data.limit ?? limit);
    if (!Number.isSafeInteger(size) || size <= 0) throw new Error('목록 페이지 정보를 확인하지 못했습니다.');
    if (page === 1) pages = Math.ceil(Number(data.total) / size);
    rows.push(...data.rows);
  }
  return rows;
}

export async function getPaymentSalespeople(signal) {
  const rows = await allRows('/api/cp/terminal/', { status: 'ACTIVE' }, 500, signal);
  return rows.filter(row => isPaymentPk(row.id) && row.status === 'ACTIVE'
    && ![true, 1, '1'].includes(row.is_demo));
}

export async function getPaymentCustomers(terminalId, signal) {
  if (!isPaymentPk(terminalId)) throw new Error('영업자를 선택해 주세요.');
  const rows = await allRows('/api/cp/customer', { terminalId: Number(terminalId), status: 'ACTIVE' }, 100, signal);
  return rows.filter(row => isPaymentPk(row.id) && String(row.terminal_id) === String(terminalId)
    && row.status === 'ACTIVE' && row.pharmacy_status === 'ACTIVE');
}

export function submitCpMappedPayment(payload) {
  // No auto retry. Keep CP identity and all generated names out of the request.
  const { terminalId, customerMapId, mchtTrdNo, trdAmt, instmtMon, cardNo, vldDtMon, vldDtYear, email, phone } = payload;
  return request({ method: 'POST', url: '/api/cp/payment/manual', timeout: 90000, data: {
    terminalId, customerMapId, mchtTrdNo, trdAmt, currency: 'KRW', instmtMon,
    cardNo, vldDtMon, vldDtYear,
    ...(email ? { email } : {}), ...(phone ? { phone } : {}),
  } });
}

export function classifyCpPayment(body) {
  const data = body?.data || {};
  const status = String(data.status || '').toUpperCase();
  const code = Number(body?.code);
  if (status === 'UNKNOWN' || data.adminReviewRequired === true) return 'unknown';
  if (code === 1000 && status === 'COMPLETED') return 'completed';
  if (status === 'FAILED') return 'failed';
  if (code === 9999) return 'login';
  if ([4000, 4040, 4030, 4031].includes(code)) return 'rejected';
  // Missing responses, processing and order conflicts must not be reported as failures.
  return 'unknown';
}
